<micro-select-combo #sel
              placeholder="Client"
              routerBase="clients"
              valueField="clientId"
              [mode]="mode"
              [(id)]="clientId"
              (idChange)="change($event)"
              [options]="options"

              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
